// This JavaScript file is created by Cision for our orderbook module.
// This is the first version of this file so far.
// This should be combined with orderbook.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.orderbook = !cision.websolution.settings.orderbook ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.orderbook.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var render = function (options) {
        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your orderbook access key.");
            return;
        }
        var url = generateUrl('OrderBook/' + accessKey + '/Items');

        $.ajax({
            url: url,
                type: 'GET',
                dataType: 'json'
            })
            .done(function(dataObj) {
                renderResult(dataObj, texts);
            })
            .fail(function() {
                console.log('Could not retrieve data');
            });

    };

    function renderResult(dataObj, texts) {
        var objInstrument = dataObj.Instruments[0],
            max = 0;

        objInstrument.LastUpdateFormatted = moment(objInstrument.LastUpdate).locale(settings.uiLanguage).calendar();

        $.each(objInstrument.OrderBookItems, function (idx, objItem) {
            max = Math.max(max, objItem.BidPrice * objItem.BidQuantity, objItem.AskPrice * objItem.AskQuantity);
        });

        $.each(objInstrument.OrderBookItems, function (idx, objItem) {
            // Calculate bar size
            objItem.BidVisualComparison = 100 * objItem.BidPrice * objItem.BidQuantity / max;
            objItem.AskVisualComparison = 100 * objItem.AskPrice * objItem.AskQuantity / max;
        });

        var compositeModel = $.extend({}, objInstrument, texts, settings),
            renderedHtml = $("#templateorderbook").render(compositeModel, cision.websolution.formatHelpers);

        $("#target-orderbook").html(renderedHtml);
    }

    return {
        render: render
    };
} (jQuery);